module.exports = flarum.core.compat['utils/DiscussionControls'];